import React from 'react';
import { UserAvatar } from './UserAvatar';
import { UserName } from './UserName';
import type { AgentRuntimeState, AgentRuntimeReason } from '../lib/api';

interface UserBadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  userId: string;
  displayName: string;
  role?: string;
  avatarUrl?: string | null;
  size?: number;
  state?: AgentRuntimeState;
  reason?: AgentRuntimeReason;
  disabled?: boolean;
  showPresence?: boolean;
  onAvatarClick?: () => void;
}

export function UserBadge({
  userId,
  displayName,
  role,
  avatarUrl,
  size = 36,
  state,
  reason,
  disabled,
  showPresence,
  onAvatarClick,
  style,
  ...rest
}: UserBadgeProps) {
  return (
    <div
      // `style` is merged rather than spread through `rest`, which would
      // replace the layout wholesale and collapse the badge.
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        cursor: onAvatarClick ? 'pointer' : undefined,
        ...style,
      }}
      onClick={onAvatarClick}
      {...rest}
    >
      <UserAvatar
        userId={userId}
        displayName={displayName}
        avatarUrl={avatarUrl}
        size={size}
        role={role}
        state={state}
        reason={reason}
        disabled={disabled}
        showPresence={showPresence}
      />
      <div style={{ flex: 1, minWidth: 0 }}>
        <div
          style={{
            fontWeight: 'inherit',
            fontSize: 14,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          <UserName displayName={displayName} role={role} />
        </div>
      </div>
    </div>
  );
}
